import { Typography } from '@mui/material';
import React from 'react';

export const NoRoutes = () => {
  return (
    <Typography variant="mlg18" color="widget.text-primary">
      No routes
    </Typography>
  );
};
